import login from './login';

export default {
  language: 'it',
  country: 'it',
  name: 'Italiano',
  embeddedLocale: login,
};
